import { Nullable } from "@/api/ApiClient";
import { WithCustomerInfo } from "./DocumentClientType";
import { WithReferenceCode } from "./ReferenceCodeType";

export interface SettlementFormCore extends WithReferenceCode<WithCustomerInfo<{
    id: string,
    tipo: string,
    numero: number,
    nombre_factura: string,
    tel1: string,
    tel1_cd: string,
    tel2: string,
    tel2_cd: string,
    email: string,
    direccion: string,
    fecha: string,
    porcenta_descuento: number,
    descuento: number,
    subtotal: number,
    total: number,
    impuestos: number,
    impuestos_servicio: number,
    anulada: boolean,
    tipo_identificacion: string,
    identificacion: string,
    pagada: boolean,
    status: string,
    exenta: boolean,
    exchange_rate: number,
    document_comments: string,
    customfields: string,
    plazo: number,
    interest_exempt: boolean,
    selected_logo: number,
    clientId: string,
    client: any,
    currencyId: string,
    currency: any,
    recibeId: string,
    recibe: any,
    settlementProducts: any[],
    settlementPayments: any[],
    interestEntries: any[],
    user: string,
}>> { }

export type SettlementFormData = Nullable<SettlementFormCore>;
export const SettlementRelatedAttributes: Array<keyof SettlementFormData> = ["clientActivitycode", "client", "currency", "recibe", "settlementProducts", "settlementPayments", "interestEntries"];